module.exports = __webpack_public_path__ + "img/logo-dark.f376cb6a.png";